import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Sticky } from "../../../types";
import { toast } from "react-toastify";

// Async Thunks
export const fetchSticky = createAsyncThunk<Sticky[], { lostId?: string; status?: number, withDeleted?: boolean }, { rejectValue: string }>("sticky/fetchSticky", async ({ lostId, status, withDeleted }, { rejectWithValue }) => {
  try {
    const apiParams = lostId ? `?lostId=${lostId}` : status ? `?status=${status}` : "";
    const withDeletedParam = withDeleted ? `&withDeleted=${withDeleted}` : "";
    const response = await api.get<ApiResponse<Sticky[]>>(`${apiEndpoints.sticky.getAll}${apiParams}${withDeletedParam}`);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch sticky.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createSticky = createAsyncThunk<Sticky, Sticky, { rejectValue: string }>("sticky/createSticky", async (newStickyData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<Sticky>>(apiEndpoints.sticky.create, { data: newStickyData });
    if (response?.success) {
      toast.success(response.message || "Sticky create successfully");
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add Escalate.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateSticky = createAsyncThunk<Sticky, Sticky, { rejectValue: string }>("sticky/updateSticky", async (updatedStickyData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<Sticky>>(`${apiEndpoints.sticky.update}/${updatedStickyData?.id}`, { data: updatedStickyData });
    if (response?.success) {
      toast.success(response.message || "Sticky updated successfully");
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update sticky.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
